var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 188.67 140.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a9d550;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-7",
    "data-name": "Layer 2-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-7",
    "data-name": "Layer 1-2-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236-2",
    "data-name": "Path 236-2",
    className: "cls-1",
    d: "M183.61,0l1.62,4.54L186.86,0h1.81V6.34H187.5V1.23l-1.76,5.11h-1L183,1.23V6.34h-1.2V0Zm-8.3,1.06V0h5.41V1.06h-2.07V6.34h-1.26V1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237-2",
    "data-name": "Path 237-2",
    className: "cls-1",
    d: "M51,.16C22.85.16,0,23.2,0,51.71V140.5H113.59c28.29,0,51.25-23.15,51.25-51.66V.16ZM21.63,118.69V106.84a5,5,0,0,1,5-5H56.46v12a4.93,4.93,0,0,1-4.88,4.92Zm55.91,0a23.89,23.89,0,0,0,.44-4.92V80H26.51a38.22,38.22,0,0,0-5,.45V78.32a14.92,14.92,0,0,1,14.86-15h63V105.7a12.81,12.81,0,0,1-12.75,12.86h-9.1ZM143.1,88.84a29.71,29.71,0,0,1-24.18,29.29,35.11,35.11,0,0,0,2.33-12.41V41.65H36.38a35.67,35.67,0,0,0-13.86,2.79A29.42,29.42,0,0,1,51,22h92.1Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.01a127768f741de0b527aca71925da95.svg";
export { ForwardRef as ReactComponent };